export default {
  email: {
    required: '사용자 이메일은 필수입니다.',
    format: '사용자 이메일은 이메일 형식이어야 합니다.',
  },
  loginId: {
    required: '아이디는 필수입니다.',
    max: '아이디는 최대 100자 입니다.',
    format: '아이디는 이메일 형식일 수 없습니다.',
  },
  password: {
    required: '비밀번호는 필수입니다.',
    format: '비밀번호는 최소 8자, 최대 100자, 숫자, 소문자, 대문자, [^$*.[]{}()?-"!@#%&/\\,><\':;|_~`+=] 특수문자를 1개 이상 포함해야 합니다.',
  },
  newPassword: {
    required: '새 비밀번호는 필수입니다.',
    same: '새 비밀번호가 기존 비밀번호와 일치합니다.',
    mismatch: '새 비밀번호가 확인 비밀번호와 다릅니다.',
  },
  confirmNewPassword: {
    required: '확인 비밀번호는 필수입니다.',
  },
  button: {
    type: '허용하지 않는 버튼 유형입니다.',
    name: {
      required: '버튼명은 필수입니다.',
      max: '버튼명은 최대 14자 입니다.',
      disallowedVariable: '버튼명은 변수 입력 불가입니다.',
    },
    mobileUrl: {
      required: '버튼 모바일 웹 링크는 필수입니다.',
      url: '버튼 모바일 웹 링크는 http:// 또는 https://로 시작하는 URL 형식이어야 합니다. (앱스킴 링크 사용 불가)',
      max: '버튼 모바일 웹 링크는 최대 500자 입니다.',
    },
    pcUrl: {
      max: '버튼 PC 웹 링크는 최대 500자 입니다.',
      url: '버튼 PC 웹 링크는 http:// 또는 https://로 시작하는 URL 형식이어야 합니다. (앱스킴 링크 사용 불가)',
    },
    androidDeepLink: {
      required: '안드로이드 앱 링크는 필수입니다.',
      max: '안드로이드 앱 링크는 최대 500자 입니다.',
    },
    iosDeepLink: {
      required: 'IOS 앱 링크는 필수입니다.',
      max: 'IOS 앱 링크는 최대 500자 입니다.',
    },
    size: '버튼은 최대 5개 까지만 설정 가능합니다.',
    businessFormEnded: '비즈니스폼(BF) 버튼은 카카오 정책에 따라 지원이 종료되었습니다. 다른 버튼 유형으로 변경해 주세요.',
    businessFormName: '비즈니스 폼 버튼명은 \'톡에서 설문하기\', \'톡에서 응모하기\', \'톡에서 예약하기\' 중 하나로만 입력할 수 있습니다.',
    bizFormKey: {
      required: '비즈니스 ID는 필수입니다.',
      disallowedVariable: '비즈니스 ID는 변수를 사용할 수 없습니다.',
      enabledVariable: '비즈니스 ID에 허용하지 않는 변수가 포함되어 있습니다.',
    },
  },
  itemList: {
    title: {
      required: '아이템 리스트의 아이템 명은 필수입니다.',
      max: '아이템 리스트의 아이템 명은 최대 6자 입니다.',
      disallowedVariable: '아이템 리스트의 아이템 명은 변수 입력 불가입니다.',
    },
    description: {
      required: '아이템 리스트의 아이템 내용은 필수입니다.',
      max: '아이템 리스트의 아이템 내용은 최대 23자 입니다.',
    },
    size: {
      min: '아이템 리스트의 아이템은 최소 2개 까지만 설정 가능합니다.',
      max: '아이템 리스트의 아이템은 최대 10개 까지만 설정 가능합니다.',
    },
    highlight: {
      title: {
        required: '아이템 하이라이트 사용을 활성화 하였습니다.\n하이라이트 타이틀을 입력해 주세요.',
        max: '하이라이트 타이틀은 최대 30자, 이미지 추가 시 21자 입니다.',
        disallowedVariable: '하이라이트 타이틀은 변수 입력 불가입니다.',
      },
      description: {
        required: '아이템 하이라이트 사용을 활성화 하였습니다.\n하이라이트 내용을 입력해 주세요.',
        max: '하이라이트 내용은 최대 19자, 이미지 추가 시 13자 입니다.',
      },
      image: {
        required: '아이템 하이라이트 이미지 사용을 활성화 하였습니다.\n이미지를 입력해 주세요',
        uuid: '아이템 하이라이트 이미지 아이디는 UUID 형식이어야 합니다.',
      },
    },
    summary: {
      title: {
        required: '아이템 요약정보 사용을 활성화 하였습니다.\n정보 타이틀을 입력해 주세요.',
        max: '아이템 요약정보 타이틀은 최대 6자 입니다.',
        disallowedVariable: '아이템 요약정보 타이틀은 변수 입력 불가입니다.',
      },
      description: {
        required: '아이템 요약정보 사용을 활성화 하였습니다.\n정보 내용을 입력해 주세요.',
        max: '아이템 요약정보 내용은 최대 14자 입니다.',
        format: '아이템 요약정보 내용은 변수 및 화폐 단위, 숫자, 쉼표, 마침표만 사용 가능합니다.',
      },
    },
    image: {
      required: '이미지 사용을 활성화 하였습니다.\n이미지를 입력해 주세요',
      uuid: '이미지 아이디는 UUID 형식이어야 합니다.',
    },
    header: {
      required: '헤더 사용을 활성화 하였습니다.\n헤더를 입력해 주세요',
      max: '헤더는 최대 23자 입니다.',
    },
  },
  department: {
    name: {
      required: '부서명은 필수입니다.',
      max: '부서명은 최대 255자 입니다.',
    },
    code: {
      required: '부서코드는 필수입니다.',
      max: '부서코드는 최대 255자 입니다.',
    },
  },
  mfa: {
    code: {
      required: '인증 코드는 필수입니다.',
      format: '인증 코드는 6자리 숫자여야 합니다.',
    },
  },
  kakaoProfile: {
    required: '카카오 프로필은 필수입니다.',
  },
  templateName: {
    required: '템플릿 명은 필수입니다.',
    max: '템플릿 명은 최대 200자 입니다.',
  },
  content: {
    required: '템플릿 내용은 필수입니다.',
    max: '템플릿 내용은 최대 1,000자 입니다.',
  },
  messageType: '허용하지 않는 메시지 유형입니다.',
  emphasizeType: '허용하지 않는 강조 유형입니다.',
  TEXT: {
    mainTitle: {
      max: '강조표기 타이틀은 최대 50자 입니다.',
      required: '강조표기 타이틀은 필수입니다.',
    },
    subTitle: {
      max: '강조표기 보조문구는 최대 50자 입니다.',
      required: '강조표기 보조문구는 필수입니다.',
      disallowedVariable: '강조표기 보조문구는 변수 입력 불가입니다.',
    },
  },
  IMAGE: {
    image: {
      required: '강조유형 이미지는 필수입니다.',
      uuid: '강조유형 이미지 아이디는 UUID 형식이어야 합니다.',
    },
  },
  EX: {
    extra: {
      required: '부가 정보형 부가 정보는 필수입니다.',
      max: '부가 정보형 부가 정보는 최대 500자 입니다.',
      disallowedVariable: '부가 정보형 부가 정보는 변수 입력 불가입니다.',
    },
  },
  AD: {
    addChannel: '채널 추가형 유형은 채널 추가 버튼이 필수입니다.',
  },
  MI: {
    addChannel: '복합형 유형은 채널 추가 버튼이 필수입니다.',
    extra: {
      required: '복합형 부가 정보는 필수입니다.',
      max: '복합형 부가 정보는 최대 500자 입니다.',
      disallowedVariable: '복합형 부가 정보는 변수 입력 불가입니다.',
    },
  },
  serviceName: {
    required: '서비스명은 필수입니다.',
    max: '서비스명은 최대 100자 입니다.',
  },
  administrator: {
    name: {
      required: '사용자 이름은 필수입니다.',
      max: '사용자 이름은 최대 100자 입니다.',
    },
    email: {
      required: '이메일은 필수입니다.',
      customEmail: '이메일은 이메일 형식이어야 합니다.',
    },
    securityPolicy: '보안 설정은 필수입니다.',
    ip: {
      required: 'IP는 필수입니다.',
      max: 'IP는 최대 50자 입니다.',
    },
    comment: {
      max: '비고는 최대 최대 100자 입니다.',
    },
  },
  inquiry: {
    file: {
      length: {
        max: '문의 등록의 첨부 파일은 최대 10개 입니다.',
      },
      size: {
        max: '첨부파일의 용량은 1MB 이하이어야 합니다.',
      },
      extension: '첨부파일의 지원하는 확장자는 (.png, .jpg, .jpeg, .gif, .pdf, .hwp, .doc, .docx) 입니다.',
      totalSize: {
        max: '첨부파일의 총용량은 5MB 이하이어야 합니다.',
      },
    },
    content: {
      required: '문의 내용은 필수입니다.',
      max: '문의 내용은 최대 300자 입니다.',
    },
  },
  rejectPhone: {
    id: {
      required: '수신거부 번호는 필수입니다.',
      uuid: '수신거부 번호는 UUID 형식이어야 합니다.',
    },
    recipientNumber: {
      required: '고객 번호는 필수입니다.',
      max: '고객 번호는 최대 25자 입니다.',
      recipientNumber: '고객 번호 형식을 확인해 주세요.',
    },
    comment: {
      max: '고객 번호는 최대 1,500자 입니다.',
    },
  },
  emailPassword: {
    mismatch: '입력하신 아이디와 이메일이 일치하지 않습니다. 다시 확인해 주세요.',
  },
  mfaRequest: {
    toManyRequest: '인증 코드 요청 한도를 초과했습니다. 잠시 후 다시 시도해 주세요.',
  },
  image: {
    name: {
      required: '이미지명을 입력해주세요.',
      max: '이미지명은 25자 이하 이여야 합니다.',
    },
    mms: {
      size: 'MMS 이미지의 용량은 500KB 이하이어야 합니다.',
      extension: 'MMS 이미지는 .jpg 형식만 지원합니다.',
    },
    normal: {
      size: '카카오톡 일반 이미지의 용량은 500KB 이하이어야 합니다.',
      extension: '카카오톡 일반 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '카카오톡 일반 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '카카오톡 일반 이미지의 너비는 4500px 이하 이어야 합니다.',
      },
      height: {
        min: '카카오톡 일반 이미지의 높이는 250px 이상 이어야 합니다.',
        max: '카카오톡 일반 이미지의 높이는 4500px 이하 이어야 합니다.',
      },
      ratio: {
        min: '카카오톡 일반 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        max: '카카오톡 일반 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
    },
    wide: {
      size: '카카오톡 와이드 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '카카오톡 와이드 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '카카오톡 와이드 이미지의 가로 길이 800px, 세로 길이 600px이어야 합니다.',
        max: '카카오톡 와이드 이미지의 가로 길이 800px, 세로 길이 600px이어야 합니다.',
      },
      height: {
        min: '카카오톡 와이드 이미지의 가로 길이 800px, 세로 길이 600px이어야 합니다.',
        max: '카카오톡 와이드 이미지의 가로 길이 800px, 세로 길이 600px이어야 합니다.',
      },
    },
    mainWideItemList: {
      size: '카카오톡 메인 와이드 아이템 리스트 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '카카오톡 메인 와이드 아이템 리스트 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '카카오톡 메인 와이드 아이템 리스트 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '카카오톡 메인 와이드 아이템 리스트 이미지의 너비는 4500px 이하 이어야 합니다.',
      },
      ratio: '카카오톡 메인 와이드 아이템 리스트 이미지의 가로 : 세로 비율은 2:1 이어야 합니다.',
    },
    wideItemList: {
      size: '카카오톡 와이드 아이템 리스트 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '카카오톡 와이드 아이템 리스트 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '카카오톡 와이드 아이템 리스트 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '카카오톡 와이드 아이템 리스트 이미지의 너비는 4500px 이하 이어야 합니다.',
      },
      ratio: '카카오톡 와이드 아이템 리스트 이미지의 가로 : 세로 비율은 1:1 이어야 합니다.',
    },
    carouselFeed: {
      size: '카카오톡 캐러셀 피드 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '카카오톡 캐러셀 피드 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '카카오톡 캐러셀 피드 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '카카오톡 캐러셀 피드 이미지의 너비는 4500px 이하이어야 합니다.',
      },
      height: {
        max: '카카오톡 캐러셀 피드 이미지의 높이는 4500px 이하이어야 합니다.',
      },
      ratio: {
        min: '카카오톡 캐러셀 피드 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        max: '카카오톡 캐러셀 피드 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
    },
    carouselCommerce: {
      size: '카카오톡 캐러셀 커머스 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '카카오톡 캐러셀 커머스 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '카카오톡 캐러셀 커머스 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '카카오톡 캐러셀 커머스 이미지의 너비는 4500px 이하이어야 합니다.',
      },
      height: {
        max: '카카오톡 캐러셀 커머스 이미지의 높이는 4500px 이하이어야 합니다.',
      },
      ratio: {
        min: '카카오톡 캐러셀 커머스 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        max: '카카오톡 캐러셀 커머스 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
    },
    alimtalk: {
      size: '알림톡 이미지의 용량은 500KB 이하이어야 합니다.',
      extension: '알림톡 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '알림톡 이미지의 너비는 500px 이상 이어야 합니다.',
      },
      height: {
        min: '알림톡 이미지의 높이는 250px 이상이어야 합니다.',
      },
      ratio: {
        min: '알림톡 이미지의 가로 : 세로 비율은 2:1 이어야 합니다.',
        max: '알림톡 이미지의 가로 : 세로 비율은 2:1 이어야 합니다.',
      },
    },
    alimtalkItemHighlight: {
      size: '하이라이트 썸네일 이미지의 용량은 500KB 이하이어야 합니다.',
      extension: '하이라이트 썸네일 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '하이라이트 썸네일 이미지의 너비는 108px 이상 이어야 합니다.',
      },
      height: {
        min: '하이라이트 썸네일 이미지의 높이는 108px 이상 이어야 합니다.',
      },
      ratio: {
        min: '하이라이트 썸네일 이미지의 가로 : 세로 비율은 1:1 이어야 합니다.',
        max: '하이라이트 썸네일 이미지의 가로 : 세로 비율은 1:1 이어야 합니다.',
      },
    },
  },
  brandImage: {
    normal: {
      size: '브랜드 메시지 일반 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '브랜드 메시지 일반 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '브랜드 메시지 일반 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '브랜드 메시지 일반 이미지의 너비는 4500px 이하 이어야 합니다.',
      },
      height: {
        min: '브랜드 메시지 일반 이미지의 높이는 250px 이상 이어야 합니다.',
        max: '브랜드 메시지 일반 이미지의 높이는 4500px 이하 이어야 합니다.',
      },
      ratio: {
        min: '브랜드 메시지 일반 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        max: '브랜드 메시지 일반 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
    },
    wide: {
      size: '브랜드 메시지 와이드 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '브랜드 메시지 와이드 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '브랜드 메시지 와이드 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '브랜드 메시지 와이드 이미지의 너비는 4500px 이하 이어야 합니다.',
      },
      height: {
        min: '브랜드 메시지 와이드 이미지의 높이는 250px 이상 이어야 합니다.',
        max: '브랜드 메시지 와이드 이미지의 높이는 4500px 이하 이어야 합니다.',
      },
      ratio: {
        min: '브랜드 메시지 와이드 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        max: '브랜드 메시지 와이드 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
    },
    mainWideItemList: {
      size: '브랜드 메시지 메인 와이드 아이템 리스트 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '브랜드 메시지 메인 와이드 아이템 리스트 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '브랜드 메시지 메인 와이드 아이템 리스트 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '브랜드 메시지 메인 와이드 아이템 리스트 이미지의 너비는 4500px 이하 이어야 합니다.',
      },
      height: {
        min: '브랜드 메시지 메인 와이드 아이템 리스트 이미지의 높이는 250px 이어야 합니다.',
        max: '브랜드 메시지 메인 와이드 아이템 리스트 이미지의 높이는 4500px 이어야 합니다.',
      },
      ratio: {
        min: '브랜드 메시지 메인 와이드 아이템 리스트 이미지의 가로 : 세로 비율은 2:1 이어야 합니다.',
        max: '브랜드 메시지 메인 와이드 아이템 리스트 이미지의 가로 : 세로 비율은 2:1 이어야 합니다.',
      },
    },
    wideItemList: {
      size: '브랜드 메시지 와이드 아이템 리스트 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '브랜드 메시지 와이드 아이템 리스트 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '브랜드 메시지 와이드 아이템 리스트 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '브랜드 메시지 와이드 아이템 리스트 이미지의 너비는 4500px 이하 이어야 합니다.',
      },
      height: {
        min: '브랜드 메시지 와이드 아이템 리스트 이미지의 높이는 250px 이어야 합니다.',
        max: '브랜드 메시지 와이드 아이템 리스트 이미지의 높이는 4500px 이어야 합니다.',
      },
      ratio: {
        min: '브랜드 메시지 와이드 아이템 리스트 이미지의 가로 : 세로 비율은 1:1 이어야 합니다.',
        max: '브랜드 메시지 와이드 아이템 리스트 이미지의 가로 : 세로 비율은 1:1 이어야 합니다.',
      },
    },
    carouselFeed: {
      size: '브랜드 메시지 캐러셀 피드 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '브랜드 메시지 캐러셀 피드 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '브랜드 메시지 캐러셀 피드 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '브랜드 메시지 캐러셀 피드 이미지의 너비는 4500px 이하이어야 합니다.',
      },
      height: {
        min: '브랜드 메시지 캐러셀 피드 이미지의 높이는 250px 이상 이어야 합니다.',
        max: '브랜드 메시지 캐러셀 피드 이미지의 높이는 4500px 이하이어야 합니다.',
      },
      ratio: {
        min: '브랜드 메시지 캐러셀 피드 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        max: '브랜드 메시지 캐러셀 피드 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
    },
    carouselCommerce: {
      size: '브랜드 메시지 캐러셀 커머스 이미지의 용량은 5MB 이하이어야 합니다.',
      extension: '브랜드 메시지 캐러셀 커머스 이미지는 .jpg 또는 .png 형식만 지원합니다.',
      width: {
        min: '브랜드 메시지 캐러셀 커머스 이미지의 너비는 500px 이상 이어야 합니다.',
        max: '브랜드 메시지 캐러셀 커머스 이미지의 너비는 4500px 이하이어야 합니다.',
      },
      height: {
        min: '브랜드 메시지 캐러셀 커머스 이미지의 높이는 250px 이상 이어야 합니다.',
        max: '브랜드 메시지 캐러셀 커머스 이미지의 높이는 4500px 이하이어야 합니다.',
      },
      ratio: {
        min: '브랜드 메시지 캐러셀 커머스 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        max: '브랜드 메시지 캐러셀 커머스 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
    },
  },
  title: '알림',
};
